import { render, staticRenderFns } from "./ButtonWithFederationSelection.vue?vue&type=template&id=5b07cdb4&scoped=true"
import script from "./ButtonWithFederationSelection.vue?vue&type=script&lang=ts"
export * from "./ButtonWithFederationSelection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b07cdb4",
  null
  
)

export default component.exports